import { call, put, select } from 'redux-saga/effects';
import { cancelCQ as cancelCQAda, cancelAll as cancelAllAda } from '@bitComponents/adabyron/cqv2';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* cancelCQ(params) {
  const {
    normalizeHttpErrors,
    cqId,
    reduxUpdate,
  } = params;
  try {
    const context = yield select(contextStore);
    const response = yield call(cancelCQAda, { cqId }, context);

    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.CANCEL_CQ, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }

    throw error;
  }
}

export function* cancelAll(params) {

  try {
    const context = yield select(contextStore);
    const response = yield call(cancelAllAda, context);

    return response;
  } catch (error) {
    console.log(error);
  }
}
